import {charcoal} from '../sass/base/_exports.sass';

export const QuestionCircleUnfilledIcon = (props) => {
  const {color = charcoal, ratio = 1} = props;

  // default dimensions
  const width = 20;
  const height = 20;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM10 18.1818C14.5187 18.1818 18.1818 14.5187 18.1818 10C18.1818 5.48131 14.5187 1.81818 10 1.81818C5.48131 1.81818 1.81818 5.48131 1.81818 10C1.81818 14.5187 5.48131 18.1818 10 18.1818ZM10.0003 14.544C9.49806 14.544 9.09091 14.1369 9.09091 13.6349C9.09091 13.1328 9.49806 12.7258 10.0003 12.7258C10.5025 12.7258 10.9097 13.1328 10.9097 13.6349C10.9097 14.1369 10.5025 14.544 10.0003 14.544ZM10.9091 11.8182H9.09091C9.09091 10.2712 9.65871 9.6088 10.9571 8.95961C11.7042 8.58607 11.8182 8.45305 11.8182 7.72727C11.8182 6.86946 11.1611 6.36364 10 6.36364C8.99585 6.36364 8.18182 7.17766 8.18182 8.18182H6.36364C6.36364 6.17351 7.99169 4.54545 10 4.54545C12.0767 4.54545 13.6364 5.74603 13.6364 7.72727C13.6364 9.27423 13.0686 9.93666 11.7702 10.5858C11.0231 10.9594 10.9091 11.0924 10.9091 11.8182Z"
        fill={color}
      />
    </svg>
  );
};
